import ExclamationmarkCircle from './ExclamationmarkCircle';

export default ExclamationmarkCircle;
